<div class="app-container">
  <app-header (loadingChange)="loading = $event"></app-header>
  <div class="main-content">
    <app-sidebar></app-sidebar>
    <main class="content-area" [ngClass]="loading ? 'loader-content' : '' ">
      <!-- Loading State -->
      <app-loading *ngIf="loading"></app-loading>
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
